import React from 'react';
import { CategoryFormData } from '../../types';
import IconPicker from '../IconPicker';
import ColorPicker from '../ColorPicker';
import sidePanelStyles from '../../../../../styles/SidePanel.module.css';

interface AppearanceTabProps {
  formData: CategoryFormData;
  onInputChange: (field: string, value: any) => void;
  onColorChange: (color: string) => void;
  onIconSelect: (iconName: string) => void;
}

const AppearanceTab: React.FC<AppearanceTabProps> = ({ 
  formData, 
  onInputChange, 
  onColorChange, 
  onIconSelect 
}) => {
  return (
    <div className={`${sidePanelStyles.tabContent} ${sidePanelStyles.active}`}>
      <div className={sidePanelStyles.formGroup}>
        <label className={sidePanelStyles.formLabel}>Category Color</label>
        <ColorPicker 
          selectedColor={formData.color}
          onColorChange={onColorChange}
        />
        <div className={sidePanelStyles.formHelp}>Choose a color that represents this category's identity</div>
      </div>
      <div className={sidePanelStyles.formGroup}>
        <label className={sidePanelStyles.formLabel}>Icon</label>
        <IconPicker 
          selectedIcon={formData.icon}
          onIconSelect={onIconSelect}
        />
      </div>
    </div>
  );
};

export default AppearanceTab;

